/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Theme Assets */
import Logo from '~/assets/theme/svg/brand-logo.svg?react';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Components */
import BrandLogo from './BrandLogo';

/* Styles */
import './Header.scss';

function Header({ hiddenRightLogo }) {
  const brandLogo = getJsonImage('brand-logo');
  return (
    <div className="dtv-html5-c-header">
      {brandLogo ? (
        <img
          src={brandLogo}
          alt="logo"
          className="dtv-html5-c-full-screen-message__logo"
        />
      ) : (
        <Logo className="dtv-html5-c-full-screen-message__logo" />
      )}
      {!hiddenRightLogo && <BrandLogo />}
    </div>
  );
}

Header.propTypes = {
  hiddenRightLogo: PropTypes.bool,
};

Header.defaultProps = {
  hiddenRightLogo: false,
};

export default memo(Header);
